import Layout from "../components/layout/Layout";
import SEO, { breadcrumbSchema, orgSchema, webPageSchema } from "../components/layout/SEO";
import Breadcrumbs from "../components/shared/Breadcrumbs";
import { Reveal } from "../components/shared/Reveal";
import { SITE } from "../data/site";
import { isTranslated } from "../data/localizedRoutes";
import { useI18n } from "../i18n";

// Reusable content-page template for legal / static pages.
// `sections` = [{ h2, body }] — body can be a string or array of paragraphs.
export default function ContentPage({ eyebrow, title, intro, path, sections = [] }) {
  const { lang } = useI18n();
  const noindex = lang !== "en" && !isTranslated(path, lang);
  return (
    <Layout>
      <SEO
        title={`${title} | ${SITE.name}`}
        description={intro || title}
        path={path}
        noindex={noindex}
        schema={[orgSchema(), webPageSchema({ name: title, description: intro || title, path }), breadcrumbSchema([{ name: "Home", to: "/" }, { name: title, to: path }])]}
      />
      <Breadcrumbs items={[{ name: title }]} />

      <article className="container-psv py-12 md:py-20 max-w-3xl">
        <Reveal>
          {eyebrow && <span className="eyebrow mb-4 block">{eyebrow}</span>}
          <h1 className="font-serif font-medium text-primary text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight">{title}</h1>
          {intro && <p className="mt-6 text-lg text-secondary-foreground font-light leading-relaxed">{intro}</p>}
        </Reveal>

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={i}>
              {s.h2 && <h2 className="font-serif text-2xl md:text-3xl text-primary mb-4">{s.h2}</h2>}
              {Array.isArray(s.body)
                ? s.body.map((p, j) => <p key={j} className="text-[16px] text-secondary-foreground leading-relaxed mb-4">{p}</p>)
                : <p className="text-[16px] text-secondary-foreground leading-relaxed">{s.body}</p>}
            </Reveal>
          ))}
        </div>
      </article>
    </Layout>
  );
}
